/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Partner_Billing_Board_Waiting_DaysInputs */



/**
* | output |
* | --- |
* | "oldest waiting {days} days" |
*
* @param {Partner_Billing_Board_Waiting_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_waiting_days = /** @type {((inputs: Partner_Billing_Board_Waiting_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Waiting_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`ältester wartet seit ${i?.days} Tagen`)
	return /** @type {LocalizedString} */ (`oldest waiting ${i?.days} days`)
});